module.exports = __webpack_public_path__ + "static/nae-logo-3b168e3bcb2f325ef940ac290eedf1ad.svg";